import wall_images from "./wall-imges";
import moment from "moment";
import { StorageService } from "../StorageUtils";

export const SHARE_ACTIVITY = "Wall Share Activity";
export const CHALLENGE_ACTIVITY = "Wall Challenge Activity";
export const EXPERIENTIAL_LEARNING_ACTIVITY = "Experiential Learning";
export const CARD_COLORS = [
  "#CEEDC7",
  "#FCF3DD",
  "#FDEEF8",
  "#E7F1FD",
  "#FEE7E7",
];
export const fetchRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * CARD_COLORS.length);
  // Pick a color using the random index
  const randomColor = CARD_COLORS[randomIndex];
  return randomColor;
};
export const HomeSortOpts = [
  "Latest",
  "Subject",
  "Most Active",
  "Activity Type",
  "My Posts",
];
export const PostsSortOpts = ["First to Last", "Last to First", "Most Active"];
export const MySpaceSortOpts = ["First to Last", "Last to First", "Subject"];
export const WallBannerTitle = "School Hub!";

export const WallTabsList = [
  // {
  //   index: 1,
  //   image: wall_images.school_hub,
  //   title: "School Hub",
  // },
  {
    index: 2,
    image: wall_images.my_class,
    title: "Experiential Hub",
  },
  {
    index: 3,
    image: wall_images.my_space,
    title: "My Space",
  },
];
export const getAttchmentType = (type) => {
  let res = MIME_TYPES.find((item) => type?.includes(item.mimeType));
  return res?.type;
};

export const MIME_TYPES = [
  {
    type: "IMAGE",
    mimeType: "image/",
  },
  {
    type: "IMAGE",
    mimeType: "image/jpeg",
  },
  {
    type: "VIDEO",
    mimeType: "video/",
  },
  {
    type: "DOC",
    mimeType: "application/msword",
  },
  {
    type: "DOC",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },
  {
    type: "PDF",
    mimeType: "application/pdf",
  },
  {
    type: "AUDIO",
    mimeType: "audio/",
  },
  {
    type: "PPT",
    mimeType: "application/vnd.ms-powerpoint",
  },
  {
    type: "PPT",
    mimeType:
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  },
  {
    type: "YOUTUBE",
    mimeType: "YOUTUBE",
  },
];

export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};
export const getCurrentDate = () => {
  const now = new Date();
  return `${now.getDate().toString().padStart(2, "0")}/${(now.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${now.getFullYear()}`;
};

export const addItemToCache = (key, value) => {
  if (window != undefined) {
    StorageService.setItem(key, JSON.stringify(value));
  }
};

export const removeItemFromCache = (key) => {
  if (window != undefined) {
    StorageService.removeItem(key);
  }
};

export const getItemFromCache = async (key) => {
  let cache = await StorageService.getItem(key);
  cache = typeof cache === "object" ? cache : JSON.parse(cache);
  return cache;
};

export const openLink = (url) => {
  window.open(url, "_blank");
};

export const getTimeInWords = (data) => {
  // var localData = data.replace("Z", ""); // Remove the 'Z' to treat it as local time
  // var momentObj = moment(localData); // Parse the date string
  // return momentObj.fromNow(); // Display the relative time from now

  const time = moment(data).format("YYYY-MM-DD HH:mm:ss");
  const parsedDate = moment(time, "YYYY-MM-DD HH:mm:ss").fromNow();
  return parsedDate;
};
const imageURL =
  "https://innerscore-student-wall.s3.amazonaws.com/7e7fa19c-b11e-412c-9c55-d36afacc34e4_Vocab_BG_4_Final.jpg";

export const handleFormatSchoolhubData = (data) => {
  data = data?.map((item, index) => {
    let obj = {
      titleImg: item?.theme?.[0]?.url,
      subject: item?.subject,
      title: item?.name,
      description: item?.description,
      showInteractions: true,
      clapsCount: item?.claps,
      commentsCount: item?.comments,
      isChallenge: !item?.isShareActivity,
      color: CARD_COLORS[index % CARD_COLORS.length],
      enableClaps: item?.enableClaps,
      enableComments: item?.enableComments,
      icons: {
        clap: wall_images.clap,
        activeClap: wall_images.activeClap,
        comment: wall_images.comment,
        challenge: wall_images.challenge,
        vote: wall_images.vote,
        activeVote: wall_images.activeVote,
      },
    };
    return { ...item, ...obj };
  });
  return data;
};

export const postMenuList = [
  // {
  //   title: "Tag to portfolio",
  //   subTitle: "Add it to the portfolio section",
  //   icon: wall_images.portifolio,
  // },
  {
    title: "Edit",
    subTitle: "Make changes in this post",
    icon: wall_images.edit,
  },
  // {
  //   title: "Hide",
  //   subTitle: "Hide from others",
  //   icon: wall_images.hide,
  // },
  // {
  //   title: "Delete",
  //   subTitle: "Delete this permanently ",
  //   icon: wall_images.delete,
  // },
];
export const postMenuListUnhide = [
  // {
  //   title: "Tag to portfolio",
  //   subTitle: "Add it to the portfolio section",
  //   icon: wall_images.portifolio,
  // },
  {
    title: "Edit",
    subTitle: "Make changes in this post",
    icon: wall_images.edit,
  },
  // {
  //   title: "Unhide",
  //   subTitle: "Make it viewable for others",
  //   icon: wall_images.hide,
  // },
  // {
  //   title: "Delete",
  //   subTitle: "Delete this permanently ",
  //   icon: wall_images.delete,
  // },
];
export const otherUserPostMenuList = [
  // {
  //   title: "Appreciate",
  //   subTitle: "Give this to the BEST!",
  //   icon: wall_images.appriciate,
  // },
  // {
  //   title: "Suggest for portfolio",
  //   subTitle: "This is worthy post for portfolio",
  //   icon: wall_images.suggestPortifolio,
  // },
  // {
  //   title: "Report",
  //   subTitle: "This bother me. Report it.",
  //   icon: wall_images.report,
  // },
];
